import PageIndex from './src/main-us';
export default PageIndex;